import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import { clerkPlugin } from '@clerk/vue';
import Notifications from '@kyvg/vue3-notification'

createApp(App)
  .use(router)
  .use(Notifications)
  .use(clerkPlugin, {
    publishableKey: process.env.VUE_APP_CLERK_PUBLISHABLE_KEY,
  })
  .mount('#app')
